module.exports = __webpack_public_path__ + "static/symbol-fadcd27bff76151b5fe9b06ad2846a82.png";